import { BookmarkAction, BookmarkActionContext } from '@/types/bookmark';
import { renderToStaticMarkup } from 'react-dom/server';

const createBookmarkActionContext = (context: BookmarkActionContext) => {
  if (context.notificationToast) {
    (typeof context.notificationToast.content !== "string") && (context.notificationToast.content = renderToStaticMarkup(context.notificationToast.content));
    (typeof context.notificationToast.duplicateContent !== "string") && (context.notificationToast.duplicateContent = renderToStaticMarkup(context.notificationToast.duplicateContent));
  }
  return context;
}

export const bookmarkUpdateActionData = (actionData: any & { bookmarkAction: BookmarkAction }) => {
  actionData?.bookmarkAction?.id &&
    actionData?.bookmarkAction?.context &&
    createBookmarkActionContext(actionData?.bookmarkAction.context);
  return actionData;
};
